import PropTypes from 'prop-types'

export default function RamStatusCheckCompare({
  side,
  isAnswered,
  valuesBefore,
  valuesAfter
}) {
  return (
    <div className="grid items-center grid-cols-12 p-3 lg:auto-rows-min print:p-2 md:gap-1 lg:gap-3 print:gap-2 print:auto-rows-auto">
      {/* COMPROVAR FILTRES / FULARD / CORRONS */}
      <div className="h-8 col-span-12 py-1 mt-5 text-sm print:col-span-3 lg:mt-0 font-ms-semi print:mt-0">
        Comprovar filtres / fulard / corrons:
      </div>

      {/* COMPROVAR DRAP TOBERES / DRAP GOMES / ENCOLADORS / MAQ. COSIR / AGULLES RAM / V.A. */}
      <div className="h-8 col-span-12 py-1 mt-5 text-sm print:col-span-3 lg:mt-0 font-ms-semi print:mt-0">
        Comprovar drap toberes / drap gomes / encoladors / maq. Cosir / agulles ram / V.A.:
      </div>

      {/* OBSERVACIONS */}
      <div className="col-span-12 mt-5 text-sm print:col-span-3 lg:mt-0 lg:col-span-4 xl:col-span-3 font-ms-semi print:mt-0">
        Observacions:
      </div>
      <div className="flex items-center h-8 col-span-12 space-x-2 cursor-not-allowed print:col-span-9 lg:col-span-8 xl:col-span-9">
        <div
          className={`flex items-center w-full h-full px-2 py-1 overflow-hidden text-base leading-tight border-b ${
            valuesBefore?.RamStatusCheckObservation !==
            valuesAfter?.RamStatusCheckObservation
              ? side === 'left'
                ? 'bg-red-100 border-red-300'
                : isAnswered
                ? 'bg-emerald-100 border-emerald-300'
                : 'bg-amber-100 border-amber-300'
              : 'border-gray-300'
          } overflow-ellipsis`}
        >
          {side === 'left'
            ? valuesBefore?.RamStatusCheckObservation
            : valuesAfter?.RamStatusCheckObservation}
        </div>
      </div>
    </div>
  )
}

RamStatusCheckCompare.propTypes = {
  side: PropTypes.string,
  isAnswered: PropTypes.bool,
  valuesBefore: PropTypes.object,
  valuesAfter: PropTypes.object
}
